import React, { useEffect, useRef } from 'react'
import MonopolioImage from '../../MonopolioImage'
import { ForRentTag, ForSaleTag } from './Tags'

import { MdOutlineBathtub, MdOutlineBed } from 'react-icons/md'
import { numberWithCommaWithoutDecimals } from '../../../utils'
import { IPointPropertiesV2 } from '@wiggot/interfaces'

// import { numberWithCommaWithoutDecimals } from '@mo/utils'

// import { useBoundStore } from '@/src/store'
// import Like from './Like'
// import { ForRentTag, ForSaleTag } from './Tags'
// import { ListingPointProperties } from '@/src/interfaces/listingInsterface'
// import MonopolioImage from '@mo/web-components/components/monopolioImage'
// import { EAmplitudeEvent } from '@/src/interfaces'
// import {
//   getProviderName,
//   prepareStringForUrlAsPropertyId
// } from '@/src/utils/propertyUtils'
// import { ITrackEventParams } from '@mo/web-components/providers/amplitud-provider/AmplitudeProvider'

interface Props {
  property: IPointPropertiesV2
  getRef: (ref: any) => void
  goToDetail: (id: string) => void
  // trackEvent: (params: ITrackEventParams) => void
  propertyType: string
}

const PropertyPopup = ({
  property,
  getRef,
  goToDetail,
  propertyType
}: Props): JSX.Element => {
  // const { setListingId } = useBoundStore((state) => state)
  const ref = useRef<any>(null)

  /**
   * This function is used to open the details of the listing
   * @returns {void}
   */
  // const openDetails = (): void => {
  // trackEvent({
  //   name: EAmplitudeEvent.LISTING_SELECTED,
  //   eventProperties: {
  //     operationType: listing?.listingType === 'for-sale' ? 'buy' : 'rent',
  //     where: 'map',
  //     provider: getProviderName(listing?.providerId),
  //     propertyId: listing?.id
  //   },
  //   configs: { login: true }
  // })
  // setListingId(
  //   listing?.itemId ? prepareStringForUrlAsPropertyId(listing) : listing?.id,
  //   'map',
  //   listing?.scraper,
  //   listing?.providerId?.toString()
  // )
  // }

  useEffect(() => {
    if (!ref.current) {
      return
    }
    getRef(ref.current)
  }, [ref.current])

  return (
    <div
      ref={ref}
      className="relative w-[286px] h-[176px] bg-white rounded-2xl overflow-hidden [box-shadow:0px_6px_40px_-6px_rgba(24,26,61,0.24)]"
    >
      <div className="absolute w-full h-full">
        <MonopolioImage
          src={property?.media[0]?.url}
          origin="twicpics"
          mode="cover"
          ratio="16/12"
        />
      </div>

      <div className="absolute w-full h-full [background:linear-gradient(0deg,rgba(0,0,0,0.65)_18.75%,rgba(0,0,0,0.00)_81.25%)]" />

      <div className="relative p-3 grid grid-cols-1 h-full">
        <div className="grid grid-cols-[auto,max-content]">
          <button
            type="button"
            className="w-full h-full cursor-pointer"
            onClick={() => goToDetail(property?.id)}
          />
        </div>
        <div
          className="flex flex-col justify-end cursor-pointer"
          onClick={() => goToDetail(property?.id)}
        >
          <div>
            {propertyType === 'for-rent' ? <ForRentTag /> : null}
            {propertyType === 'for-sale' ? <ForSaleTag /> : null}
          </div>
          <div className="mt-2 text-white text-xl font-bold flex items-center gap-1">
            <p>$</p>
            <p>
              {numberWithCommaWithoutDecimals(
                property?.priceAmount?.toString() || ''
              )}
            </p>
            <p className="text-sm font-normal">MXN</p>
          </div>
          <div className="flex items-center justify-start w-full gap-2">
            {property?.bedrooms > 0 && (
              <div className="px-[.375rem] text-white text-[10px] font-medium gap-[.25rem] rounded-[25px] bg-overlay-dark w-max items-center flex">
                {property?.bedrooms}
                <MdOutlineBed className="w-[18px] h-[18px] fill-white" />
              </div>
            )}

            {property?.bathrooms > 0 && (
              <div className="px-[.375rem] text-white text-[10px] font-medium gap-[.25rem] rounded-[25px] bg-overlay-dark w-max items-center flex">
                {property?.bathrooms}

                <MdOutlineBathtub className="w-[18px] h-[18px] fill-white" />
              </div>
            )}

            {/* {property?.parkingLots > 0 && (
              <div className="px-[.375rem] text-white text-[10px] font-medium gap-[.25rem] rounded-[25px] bg-overlay-dark w-max items-center flex">
                {property?.parkingLots} Est.
                <MdOutlineDirectionsCar className="w-[18px] h-[18px] fill-white" />
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PropertyPopup
